import { createElement, memo } from 'react';
import { resolveEventBody } from './eventBodyRegistry.js';
import DetailBodySkeleton from './DetailBodySkeleton.jsx';

/** Dispatches to the per-type detail body, falling back to the generic body. */
function EventDetailBody({ event, flush = false, loading = false }) {
  if (loading) {
    return <DetailBodySkeleton />;
  }
  return createElement(resolveEventBody(event.type), { event, flush });
}

// Memoized so dragging the CT-5308 resizable inbox list panel — which only
// changes the parent Panel's own flex-basis state — doesn't force this
// (potentially heavy, per-event-type) body to re-render on every drag frame.
// `event`/`thread` etc. are already useMemo-stabilized by useEventDetail, so
// this actually skips work instead of just being a no-op safety net.
export default memo(EventDetailBody);
